module.exports = __webpack_public_path__ + "img/img19.53777300.svg";